<template>
    <div>
        <Loader v-if="loading" />
        <div v-else class="container-fluid mt-45">
            <Breadcrumbs />
            <Searchbar class="mt-4" />

            <div v-if="!results.results.length">
                <div class="row">
                    <div class="col-md-6">
                        <div class="mt-4">
                            <div class="alert alert-info">
                                Your search query returned no results. Please try amending your search criteria
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else>
                <div class="row mt-5">
                    <div class="col">
                        <p class="h4">Results <small class="font-italic text-sm">{{ `Showing ${showingComputed} of ${results.totalCount}` }}</small></p>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col">
                        <b-table 
                            ref="table"
                            id="table"
                            :sort-by.sync="sortBySync" 
                            :sort-desc.sync="sortDesc" 
                            @sort-changed="sortingChanged" 
                            :no-local-sorting="true"
                            :busy.sync="isBusy"
                            class="custom-table bg-white" 
                            responsive
                            no-sort-reset
                            :fields="filteredTestsFields" 
                            :items="results.results"
                        >
                            <template #cell(testNumber)="data">
                                <router-link :to="{name: 'ViewTest', params: {id : data.item.id}}" class="font-weight-bold underlined text-capitalize">{{ data.item.testNumber }}</router-link>
                                <div class="test-history-icons" v-if="data.item.replacedByTestId">
                                    <img src="@/assets/images/icons/reorder-old-icon.svg" v-b-tooltip.hover title="This test has been reordered"/>
                                </div>
                                <div class="test-history-icons" v-else-if="data.item.replacesTestId">
                                    <img src="@/assets/images/icons/reorder-new-icon.svg" v-b-tooltip.hover title="This test replaces a previous test"/>
                                </div>
                                <div class="test-history-icons" v-else-if="data.item.hasBeenPreviouslyReordered">
                                    <img src="@/assets/images/icons/reorder-old-icon.svg" v-b-tooltip.hover title="Test has been previously reordered"/>
                                </div>
                            </template>

                            <template #cell(patientName)="data">
                                <router-link class="font-weight-bold underlined text-capitalize" :to="{name: 'ViewPatient', params: {id : data.item.patientId}}">{{ data.item.patientName }}</router-link>
                            </template>

                            <template #cell(patientPostalCode)="data">
                                <span class="text-uppercase">{{ data.item.patientPostalCode }}</span>
                            </template>

                            <template #cell(status)="data">
                                <testStatuses :status="data.item.status" />
                            </template>

                            <template #cell(action)="data">
                                <router-link :to="{name: 'ViewTest', params: {id : data.item.id}}" class="btn btn-primary sm-shadow text-nowrap">View Test</router-link>
                            </template>
                        </b-table>

                        <div class="mt-4">
                            <b-pagination
                                v-model="currentPage"
                                :current-page="currentPage"
                                :per-page="results.pageSize"
                                :total-rows="results.totalCount"
                                prev-text="< Previous"
                                next-text="Next >"
                                @change="pageChange"
                                aria-controls="table"
                                hide-goto-end-buttons
                                prev-class="prev-page"
                                next-class="next-page"
                                align="right"
                            ></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from '@/partials/Loader'
import Breadcrumbs from '@/partials/site-structure/BreadcrumbsComponent.vue'
import Searchbar from '@/components/SearchbarComponent.vue'
import TestStatuses from '../../../Common/components/TestStatusesComponent.vue'
import SearchResultsMixin from '@/mixins/SearchResultsMixin'
import FormatterMixin from '../../../Common/mixins/FormatterMixin'
import TotalResultsMixin from '../../../Common/mixins/TotalResultsMixin'
export default {
    name: 'SearchResults',

    components: {
        Breadcrumbs,
        Searchbar,
        Loader,
        TestStatuses
    },

    mixins: [
        TotalResultsMixin,
        FormatterMixin,
        SearchResultsMixin
    ]
}
</script>